import { manipulateDigitalData } from '@aoworld-aotech/digital-data';

import { UPDATE_DOCUMENT_INFORMATION } from '../actions/lister-actions';

export function updateDocumentTitle(title) {
	const hostname = window.location.hostname;
	if (title) {
		const documentTitle = `${title} | ${hostname}`.replace('  ', ' ');

		document.title = documentTitle;
		return;
	}

	document.title = hostname;
	return;
}

export function updateMetaDescription(description) {
	if (description) {
		const metaDescriptionElement = document.querySelector(
			'meta[name="description"]'
		);

		if (!metaDescriptionElement) return;

		metaDescriptionElement.setAttribute('content', description);
	}

	return;
}

export function updateCanonical(link) {
	if (link) {
		const canonical = document.querySelector('link[rel="canonical"]');

		if (!canonical) return;

		canonical.setAttribute('href', link);
	}

	return;
}

export function updateStructuredData(structuredData) {
	const structuredDataId = 'lister-structured-data';
	let existingScript = document.getElementById(structuredDataId);

	if (!structuredData) {
		existingScript?.remove();
		return;
	}

	if (!existingScript) {
		existingScript = document.createElement('script');
		existingScript.id = structuredDataId;
		existingScript.type = 'application/ld+json';
		document.head.appendChild(existingScript);
	}

	existingScript.textContent = structuredData;
}

export function updateDigitalData({ CategorisationTagViewModel }) {
	if (!CategorisationTagViewModel) {
		return;
	}

	const {
		ApplianceType,
		HighLevelCategory,
		MainCategory,
		SubCategory,
	} = CategorisationTagViewModel;

	manipulateDigitalData({
		page: {
			productDiscovery: {
				listerPage: {
					applianceType: ApplianceType,
				},
			},
			pageInfo: {
				mainCategory: HighLevelCategory,
				subCategory: MainCategory,
				realSubCategory: SubCategory,
			},
		},
	});
}

export const updateDocumentInformation = (store) => (next) => (action) => {
	next(action);

	const {
		pageTitle,
		pageDescription,
		canonical,
		structuredData,
		featureSwitches,
		adobeTagging,
		drawer: { drawerOpen } = {},
	} = store.getState();

	switch (action.type) {
		case UPDATE_DOCUMENT_INFORMATION:
			if (drawerOpen) {
				return;
			}

			updateDocumentTitle(pageTitle);
			updateMetaDescription(pageDescription);
			updateCanonical(canonical);

			if (featureSwitches?.StructuredDataEnabled) {
				updateStructuredData(structuredData);
			}

			updateDigitalData(adobeTagging);

			break;

		default:
			break;
	}
};
